module.exports = __webpack_public_path__ + "img/11.aad44bd4.png";